import type { ReactNode } from 'react';
import { Flex, Progress, Typography, theme } from 'antd';

const { Text } = Typography;

interface OutcomeSummaryProps {
  /** The verdict — "done", "3 need attention". */
  headline: ReactNode;
  /** The scale it is measured against, right-aligned. */
  aside: ReactNode;
  /** How much of the run succeeded, 0–100. */
  percent: number;
  /** Paints the bar red: something failed outright. */
  exception?: boolean;
  /** What the bar is a fraction of, for screen readers. */
  progressLabel?: string;
}

/**
 * Header of a run-result view. The headline is announced: a run finishes
 * while the modal is open and the reader may not be looking at it.
 */
export const OutcomeSummary = ({
  headline,
  aside,
  percent,
  exception,
  progressLabel,
}: OutcomeSummaryProps) => {
  const { token } = theme.useToken();

  return (
    <>
      <div aria-live="polite" aria-atomic="true">
        <Flex justify="space-between" align="baseline">
          <Text strong>{headline}</Text>
          <Text type="secondary">{aside}</Text>
        </Flex>
      </div>
      <Progress
        percent={percent}
        showInfo={false}
        status={exception ? 'exception' : undefined}
        strokeColor={token.colorSuccess}
        aria-label={progressLabel}
      />
    </>
  );
};
